// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { server16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-server': IconServer;
    }
}

/**
 * The icon component for the 'server' icon
 */
export class IconServer extends Icon {
    public constructor() {
        super(server16X16);
    }
}

registerIcon('icon-server', IconServer);
export const iconServerTag = 'nimble-icon-server';
